import { useRouter } from "next/router";
import { useEffect, useState } from "react";

import { ContentName, contentNameSchema } from "~/components/me/lib";

type OpenableContent = Exclude<ContentName, "FussyAttestation">;

type UseOpenContentModalProps = {
  openedContent: OpenableContent | null;
  openContentModal: (contentName: OpenableContent) => void;
  closeContentModal: () => void;
};

export function useOpenContentModal(): UseOpenContentModalProps {
  const router = useRouter();
  const [openedContent, setOpenedContent] = useState<OpenableContent | null>(
    null
  );

  const openContentModal = (
    contentName: Exclude<ContentName, "FussyAttestation">
  ) => {
    setOpenedContent(contentName);
  };

  const closeContentModal = () => {
    setOpenedContent(null);
  };

  useEffect(() => {
    const { content } = router.query;
    if (typeof content !== "string") return;

    const result = contentNameSchema.safeParse(content);
    if (result.success) {
      const { data } = result;
      if (data !== "FussyAttestation") {
        setOpenedContent(data);
      }
    }
  }, [router]);

  return { openedContent, openContentModal, closeContentModal };
}
